import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { PRIMARY, makeThemeColor, TERTIARY } from '@tornado-rdk/theme';

export const BORDER_RADIUS = {
  [HD]: 4,
  [FULL_HD]: 4,
};

export const STROKE_UNFOCUSED = {
  [HD]: 2,
  [FULL_HD]: 3,
};

export const STROKE_FOCUSED = {
  [HD]: 2,
  [FULL_HD]: 3,
};

export const STROKE_UNFOCUSED_COLOR = makeThemeColor(PRIMARY, 1.0);

export const STROKE_FOCUSED_COLOR = makeThemeColor(PRIMARY, 1.0);

export const FILL_UNFOCUSED_COLOR = makeThemeColor(TERTIARY);

export const FILL_SELECTED_COLOR = makeThemeColor(PRIMARY, 0.6);

export const FILL_FOCUSED_COLOR = makeThemeColor(PRIMARY);

export const TEXT_UNFOCUSED_COLOR = makeThemeColor(PRIMARY);

export const TEXT_SELECTED_COLOR = makeThemeColor(TERTIARY);

export const TEXT_FOCUSED_COLOR = makeThemeColor(TERTIARY);

export const SCALE_FOCUSED = 1.05;
